import React, {useCallback, useContext, useState} from 'react';
import AddWaitListEntry from "./AddWaitListEntry";
import BruceModeContext from '../contexts/BruceModeContext';

const WaitListEntry = (props) => {

    const [open, setOpen] = useState(false);
    const [bM, setBM] = useContext(BruceModeContext);

    const closeOpenHandler = () => {
        setOpen(false);
    }

    return (
        <div id="wait-entry-container" style={bM.isBruce ? {backgroundColor: 'black', color: 'white'} : {}} onClick={() => setOpen(true)}>

            {open ? <AddWaitListEntry toggle={props.toggle} setToggle={props.setToggle} data={props.data} open={true} closeOpen={closeOpenHandler}/> : (
                <>

                    <span className="wait-name-span">
                        {props.data.notes === "" || props.data.notes === " " ? props.data.name : `${props.data.name}***`}
                    </span>
                    <span className="wait-people-span">{props.data.people}p</span>
                    <div className="wait-seating-span">

                        {
                            props.data.seating.map((e, i) => {
                                if (e === " ") {
                                    // do nothing
                                } else {
                                    return (
                                        <span key={`spanny-${i}`}>
                         {` S${e }`}
                </span>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                </>
            )}
        </div>
    );
};

export default WaitListEntry;
